import { VOCategory, VOHome, VOMenuCategory } from "../model/DataStructure.js";

export class Menu {
    public onRequestCategory = e5.Signal.create<[VOCategory]>();

    public element: HTMLDivElement;

    constructor(home: VOHome) {
        this.element = document.createElement("div");
        this.element.id = "menu";
        this.element.className = "active";

        for (var menu of home.menus) {
            var mainNavItem = new MenuItem(menu);
            this.element.appendChild(mainNavItem.element);
            mainNavItem.onClick.add((n) => this.onRequestCategory.dispatch(n.category));
        }
    }

    public get active(): boolean {
        return this.element.classList.contains("active");
    }

    public set active(active: boolean) {
        this.element.classList.toggle("active", active);
    }
}

class MenuItem {

    public category: VOCategory;
    public onClick = e5.Signal.create<[MenuItem]>();
    public element: HTMLDivElement;

    //VOMenuCategory
    constructor(public menu: VOMenuCategory) {
        this.element = document.createElement("div");
        this.element.className = "menu-item " + "main";
        this.element.innerHTML = `
        <div class="menu-item-label">${menu.home_menu.title}</div>
        <div class="menu-item-icon ${menu.home_menu_icon || "icon-49"}"></div>`;

        this.category = menu.home_menu;

        this.element.addEventListener("click", () => this.onClick.dispatch(this as any));
    }
}